import { render, staticRenderFns } from "./social-media-field.vue?vue&type=template&id=6df25eb6"
import script from "./social-media-field.vue?vue&type=script&lang=js"
export * from "./social-media-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports